import './SiteAlert.scss';
import Component from './SiteAlert.js';
export default Component;
